import { CompublishContext } from "@/contexts/compublishContext";
import { RoleContext } from "@/contexts/roleContext";
import { StorageContext } from "@/contexts/storageContext";

import { useContext } from "react";

const useRole = () => useContext(RoleContext);
const useStorage = () => useContext(StorageContext);
const useCompublish = () => useContext(CompublishContext);

export { useCompublish, useRole, useStorage };
